export function noop() {
    // no operation
}
export default noop;
//# sourceMappingURL=no-op.js.map